import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {searchAdSetsWithSearchCriteria} from "../../services/facebook-ad-set-data.service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import AddEditAdSet from "./add-edit-ad-set";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {AD_SET_FIELDS_LIST, AD_SET_INFO_FIELDS_LIST} from "../../constants/ad-set.constant";
import AddEditMultipleImageMedia from "../../../marketing/components/media-editor/add-edit-multiple-image-media";
import {
    deleteSingleFacebookAdCreative,
    searchFacebookAdCreativesWithSearchCriteria
} from "../../services/facebook-ad-creative-data.service";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";
import CreateFacebookAd from "../ad/create-facebook-ad";
import {
    deleteAd,
    deleteAdCreative,
    getAdImagesByHashes,
    getAdsByAdCampaign,
    getAdsByAdSet
} from "../../services/facebook-ads-service";
import {deleteSingleFacebookAd, searchFacebookAdsWithSearchCriteria} from "../../services/facebook-ad-data.service";
import DeleteItem from "../../../common/ui/delete-item";
import ShowFacebookStatus from "../facebook/show-facebook-status";
import EditFacebookAdSet from "./edit-facebook-ad-set";

const defaultFilterCriteria: any = {};

const AdSetsListWithAdCreatives = ({campaign = undefined, designDetail = undefined}) => {
    const [adSetsList, setAdSetsList] = useState(null);
    const [adImagesList, setAdImagesList] = useState(null);
    const [adCreativesList, setAdCreativesList] = useState(null);
    const [adCreativesBySetMap, setAdCreativesBySetMap] = useState(null);
    const [adsMap, setAdsMap] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [expandedAdSetsMap, setExpandedAdSetsMap] = useState({});

    const getAdSetList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        if (campaign) {
            searchCriteriaList.push({field: 'campaign_id', condition: '==', value: campaign?.id});
        }

        if (designDetail) {
            searchCriteriaList.push({field: 'designId', condition: '==', value: designDetail?.id});
        }

        const adSetListResult = await searchAdSetsWithSearchCriteria(searchCriteriaList);
        setAdSetsList(adSetListResult);
        setDataFetchInProgress(false);
        console.log('adSetListResult', adSetListResult);
    }

    const getAdCreativeList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        if (campaign) {
            searchCriteriaList.push({field: 'campaignId', condition: '==', value: campaign?.id});
        }

        if (designDetail) {
            searchCriteriaList.push({field: 'designId', condition: '==', value: designDetail?.id});
        }

        const adCreativeListResult = await searchFacebookAdCreativesWithSearchCriteria(searchCriteriaList);
        const tempAdCreativesBySetMap = _.groupBy(adCreativeListResult, 'adSetId');
        setAdCreativesBySetMap(tempAdCreativesBySetMap);

        console.log('adCreativeListResult', adCreativeListResult);

        const imageHashes = [];

        adCreativeListResult?.forEach(adCreative => {
            adCreative?.images?.forEach(image => {
                imageHashes.push(image?.hash);
            })
        });

        /*const adImageListResult = await getAdImagesByHashes(imageHashes);
        console.log('adImageListResult', adImageListResult);*/

        setAdCreativesList(adCreativeListResult);
        setDataFetchInProgress(false);
    }

    const getAdList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        if (campaign) {
            searchCriteriaList.push({field: 'campaignId', condition: '==', value: campaign?.id});
        }

        if (designDetail) {
            searchCriteriaList.push({field: 'designId', condition: '==', value: designDetail?.id});
        }

        const adListResult = await searchFacebookAdsWithSearchCriteria(searchCriteriaList);
        const tempAdsMap = _.keyBy(adListResult, 'adCreativeId');
        setAdsMap(tempAdsMap);

        console.log('adListResult', adListResult);

        setDataFetchInProgress(false);
    }

    useEffect(() => {
        refreshAdSetList();
    }, [filterCriteria]);

    const refreshAdSetList = async () => {
        await getAdSetList();
        await getAdCreativeList();
        await getAdList();
    }

    const refreshAdCreativeList = async () => {
        await getAdCreativeList();
        await getAdList();
    }

    const toggleAdCreativesVisibility = async (adSet) => {
        const tempExpandedAdSetsMap = {...expandedAdSetsMap};
        tempExpandedAdSetsMap[adSet?.id] = !tempExpandedAdSetsMap[adSet?.id];
        setExpandedAdSetsMap(tempExpandedAdSetsMap);

        const facebookAdListByAdSetResult = await getAdsByAdSet(adSet);
        const facebookAdsByIdMap = _.keyBy(facebookAdListByAdSetResult, 'id');
        const existingAdsList = _.values({...adsMap});

        _.forEach(existingAdsList, (adDetail) => {
            adDetail['status'] = facebookAdsByIdMap[adDetail?.adId]?.status || 'DELETED';
        });

        const tempAdsMap = _.keyBy(existingAdsList, 'adCreativeId');
        setAdsMap(tempAdsMap);

        console.log('facebookAdListByAdSetResult', facebookAdListByAdSetResult);
        console.log('existingAdsMap', tempAdsMap);
    }

    const deleteAdCreativeAndAd = async (adCreative, ad) => {
        const deletedFacebookAd = await deleteAd(ad);
        const deletedFacebookAdCreative = await deleteAdCreative(adCreative);
        await deleteSingleFacebookAd(ad);
        await deleteSingleFacebookAdCreative(adCreative);
        refreshAdCreativeList();
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Campaign Ad Sets
                    </div>

                    {/*<AdSetFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/6 flex items-center justify-end">
                    {!campaign &&
                        <div className="ml-2">
                            <AddEditAdSet
                                isAddAdSet={true}
                                refreshAdSetList={refreshAdSetList}/>
                        </div>
                    }
                </div>

            </div>

            <div className="justify-start w-full">

                {adSetsList?.length === 0 &&
                    <div className="w-full bg-white mt-4">
                        <ShowEmptyListMessage
                            dataList={adSetsList}
                            dataFetchInProgress={dataFetchInProgress}
                            label={'Ad Sets'}/>
                    </div>
                }

                {adSetsList?.length > 0 &&
                    <div className="flex flex-col">
                        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-50">
                                        <tr>
                                            <th scope="col"
                                                className="px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider">
                                                <div>Show/Hide</div>
                                                <div>Ad Creatives</div>
                                            </th>
                                            {AD_SET_INFO_FIELDS_LIST.map((adSetField, adSetFieldIndex) => (
                                                <th
                                                    key={adSetFieldIndex}
                                                    scope="col"
                                                    className="px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">
                                                    {adSetField?.label}
                                                </th>
                                            ))}

                                            <th scope="col"
                                                className="px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">
                                                Actions
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                        {adSetsList.map((adSet, adSetIndex) => (
                                            <React.Fragment key={`adSet-${adSetIndex}`}>
                                                <tr>
                                                    <td className="px-6 py-4 text-center whitespace-nowrap">
                                                        {expandedAdSetsMap && adCreativesBySetMap && adCreativesBySetMap[adSet?.id] &&
                                                            <div>
                                                                <button
                                                                    className={`px-2 py-1 ${expandedAdSetsMap[adSet?.id] ? 'button-sky-outline' : 'button-sky'}`}
                                                                    onClick={() => toggleAdCreativesVisibility(adSet)}>
                                                                    {expandedAdSetsMap[adSet?.id] ? 'Hide' : 'Show'} ({adCreativesBySetMap[adSet?.id]?.length})
                                                                </button>
                                                            </div>
                                                        }
                                                    </td>
                                                    {AD_SET_INFO_FIELDS_LIST.map((adSetField, adSetFieldIndex) => (
                                                        <td key={`adSetField-${adSetFieldIndex}`}
                                                            className="px-6 py-4 whitespace-nowrap">
                                                            {!adSetField?.isStatus &&
                                                                <div
                                                                    className="text-gray-900">{adSet[adSetField?.attribute]}</div>
                                                            }

                                                            {adSetField?.isStatus &&
                                                                <ShowFacebookStatus
                                                                    status={adSet?.status}/>
                                                            }
                                                        </td>
                                                    ))}
                                                    <td className="px-6 py-4 whitespace-nowrap flex">
                                                        <div className={'m-1'}>
                                                            <EditFacebookAdSet
                                                                adSet={adSet}
                                                                afterCreateOrEditAdSetAction={refreshAdSetList}/>
                                                        </div>
                                                        <div className={'m-1'}>
                                                            <AddEditMultipleImageMedia
                                                                isAddImageMedia={true}
                                                                adSet={adSet}
                                                                afterSaveAction={refreshAdCreativeList}
                                                                cssClass={'button-green-outline px-2 py-1'}/>
                                                        </div>
                                                    </td>
                                                </tr>

                                                {expandedAdSetsMap[adSet?.id] &&
                                                    <tr className={''}>
                                                        <td colSpan={AD_SET_INFO_FIELDS_LIST?.length + 2}
                                                            className="px-4 py-4">
                                                            {adCreativesBySetMap && adCreativesBySetMap[adSet?.id] &&
                                                                <div
                                                                    className="flex flex-wrap justify-start items-stretch">
                                                                    {adCreativesBySetMap[adSet?.id]?.map((adCreative, adCreativeIndex) => (

                                                                        <div key={`adCreative-${adCreativeIndex}`}
                                                                             className={'w-96 border bg-gray-100 m-4 p-4 rounded-lg'}>

                                                                            <div
                                                                                className={'px-1 pt-1 flex justify-between items-center'}>

                                                                                <div>
                                                                                    <ShowFacebookStatus
                                                                                        status={adsMap[adCreative?.id]?.status}/>
                                                                                </div>

                                                                                <div className={''}>
                                                                                    <DeleteItem
                                                                                        handleDeleteItem={() => {
                                                                                            deleteAdCreativeAndAd(adCreative, adsMap[adCreative?.id]);
                                                                                        }}
                                                                                        iconSize={'h-5 w-5'}
                                                                                        itemIndex={adCreativeIndex}
                                                                                        showIcon={true}/>
                                                                                </div>
                                                                            </div>

                                                                            <div
                                                                                className={'px-0 py-2 flex justify-start items-center'}>
                                                                                <div className={'m-1'}>
                                                                                    <CreateFacebookAd
                                                                                        existingAd={adsMap && adsMap[adCreative?.id]}
                                                                                        adSet={adSet}
                                                                                        adCreative={adCreative}
                                                                                        afterCreateOrEditAdAction={refreshAdCreativeList}/>
                                                                                </div>

                                                                                <div className={'m-1'}>
                                                                                    <AddEditMultipleImageMedia
                                                                                        isCopyImageMedia={true}
                                                                                        adSet={adSet}
                                                                                        adCreative={adCreative}
                                                                                        afterSaveAction={refreshAdCreativeList}
                                                                                        cssClass={'button-sky-outline px-2 py-1'}/>
                                                                                </div>
                                                                            </div>

                                                                            <div
                                                                                className="h-fit flex flex-wrap justify-start items-center">
                                                                                {adCreative?.images?.map((adCreativeImage, adCreativeImageIndex) => (
                                                                                    <React.Fragment
                                                                                        key={adCreativeImageIndex}>
                                                                                        <ProductImageSmall
                                                                                            dimension={75}
                                                                                            imageUrl={adCreativeImage?.permalink_url}
                                                                                            afterImageSelected={() => {
                                                                                                window.open(adCreativeImage?.permalink_url, '_blank');
                                                                                            }}/>
                                                                                    </React.Fragment>
                                                                                ))}
                                                                            </div>
                                                                        </div>

                                                                    ))}
                                                                </div>
                                                            }
                                                        </td>
                                                    </tr>
                                                }
                                            </React.Fragment>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </div>

        </>
    )
}

export default AdSetsListWithAdCreatives
